export const defaultLimit = "10";

export const defaultOffset = "0";
